module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="video" data-w="'+
((__t=( content.w ))==null?'':__t)+
'" data-h="'+
((__t=( content.h ))==null?'':__t)+
'">\n  	<div class="video-inner" style="width:'+
((__t=( content.w ))==null?'':__t)+
'px; height:'+
((__t=( content.h ))==null?'':__t)+
'px" >\n    	<iframe id="" class="onemodal-iframe" scrolling="auto" frameborder="0" allowfullscreen="" mozallowfullscreen="" webkitallowfullscreen="" hspace="0" vspace="0" name="" src="'+
((__t=( content.url ))==null?'':__t)+
'?autoplay=1&hd=1&show_title=1&show_byline=1&show_portrait=0&fullscreen=1" style="width: 100%; height: 100%;">\n    	</iframe>\n    </div>\n</div>';
}
return __p;
};
